import React, { Component } from "react";
import Wrapper from "../../../../_hoc/Wrapper";
import SimpleList from "../../../UI/SimpleList";

const simpleListItem = [
  {
    text: ({ createdBy }) => (
      <Wrapper>
        <i className="fa fa-address-book" />
        Profile Created by <strong>{createdBy}</strong>
      </Wrapper>
    )
  }
];

const simpleListItemWithMobileNumber = [
  {
    text: ({ createdBy }) => (
      <Wrapper>
        <i className="fa fa-address-book" />
        Profile Created by <strong>{createdBy}</strong>
      </Wrapper>
    )
  },
  {
    text: ({ mobile }) => (
      <Wrapper>
        <i className="fa fa-phone" /> {mobile}
      </Wrapper>
    )
  }
];

export default class ProfileMobileInfo extends Component {
  render() {
    const { mobile } = this.props;

    return (
      <SimpleList
        items={mobile ? simpleListItemWithMobileNumber : simpleListItem}
        component={this}
        hover
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileMobileInfo/index.js